export default (state, action) => {
  const { expandedItems } = state;
  const { itemId } = action.payload;

  const alreadyExpanded = expandedItems.indexOf(itemId) !== -1;

  const newlist = alreadyExpanded
    ? expandedItems.filter(id => id !== itemId)
    : expandedItems.concat([itemId]);

  return {
    ...state,
    expandedItems: newlist,
  };
};
